export default __webpack_public_path__ + "static/media/girl-laundry.f735536d.jpg";